import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  refresh(event) {
    if (event.detail.success) document.dispatchEvent(new CustomEvent("annotations:changed"))
  }
}
